<template name = "dateTemplate" lang="html">
		<!-- Create From -->
		<!-- Top bar-->
	<div class="row">
		<b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true"></b-loading>
		<div id="header"></div>
		<div class="row">
			<div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
				<div class="sidebar-header">
					<h5>Search</h5>
					<a href="" id="sidebarMenuClose"><i data-feather="x"></i></a>
				</div><!-- df-sidebar-header -->
				<div class="sidebar-body"></div>
			</div><!-- sidebar-body -->
		</div><!-- sidebar -->
		<div class="content content-components">
			<div class="container pd-x-0 pd-lg-x-12 pd-xl-x-0 bs">  
				<div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
					<div>
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb breadcrumb-style1 mg-b-10">
							<li class="breadcrumb-item">{{this.mainName}}</li>
							<li class="breadcrumb-item active" aria-current="page">{{this.subName}}</li>
							</ol>
							<h4 class="mg-b-0 tx-spacing--1">{{this.subName}}</h4>
						</nav>
					</div>
					<div class="d-none d-md-block">
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-on:click="saveFilter()"><i data-feather="folder" class="wd-10 mg-r-5"></i>Save</button>
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-on:click="goList()"><i data-feather="file" class="wd-10 mg-r-5"></i>list</button>
					</div>
				</div>
				<div class="mg-t-100 bs2">
					<div class="card ht-100p">
						<form action="form-validation.html" data-parsley-validate class="card-body list-group list-group-flush tx-13list-group list-group-flush tx-13 d-block">
							<div class="form-row col-md-5 d-block position-relative float-left">
								<div class="form-group">
									<label for="input1">아이디 <span class="tx-danger">*</span></label>
									<input type="text" v-model.trim="userId" class="form-control" ref="userId" id="userId" placeholder="아이디">
								</div>
							</div>
							<div class="form-row col-md-5 d-block position-relative float-left">
								<div class="form-group">
									<label for="input4">이름 <span class="tx-danger">*</span></label>
									<input type="text" ref="userName" v-model.trim="userName" class="form-control" id="userName" placeholder="이름">
								</div>
							</div>
                            <div class="form-row col-md-5 d-block position-relative float-left">
								<div class="form-group">
									<label for="input4">전화번호 <span class="tx-danger"></span></label>
									<input type="text" ref="phone" v-model.trim="phone" class="form-control" id="phone" placeholder="전화번호">
								</div>
							</div>
                            <div class="form-row col-md-5 d-block position-relative float-left">
								<div class="form-group">
									<label for="input4">E-mail <span class="tx-danger"></span></label>
									<input type="text" ref="email" v-model.trim="email" class="form-control" id="email" placeholder="E-mail">
								</div>
							</div>
							<div class="form-row col-md-5 d-block position-relative float-left">
								<div class="form-group">
									<label for="input2">패스워드 <span class="tx-danger">*</span></label>
									<input type="password" v-model.trim="password" class="form-control" ref="password" id="password" placeholder="패스워드">
								</div>
							</div>
							<div class="form-row col-md-5 d-block position-relative float-left">
								<div class="form-group">
									<label for="input3">패스워드 확인 <span class="tx-danger">*</span></label>
									<input type="password" v-model.trim="passwordRe" class="form-control" ref="passwordRe" id="passwordRe" placeholder="패스워드">
								</div>
							</div>
							<div class="form-row col-md-4 d-block position-relative float-left" v-for="(form, i) in codeData" v-if="form.code=='C022'">
								<div class="form-group">
									<label for="input4">직급</label>
									<b-select placeholder="Select a position" rounded v-model="position">
										<option v-for="sub in form.sub" :value="sub.codeCode" :key="sub.id">{{sub.codeName}}</option>
									</b-select>
								</div>
							</div>
							<div class="form-row col-md-4 d-block position-relative float-left" v-else>
								<div class="form-group">
									<label for="input4">직책</label>
									<b-select placeholder="Select a position" rounded v-model="official">
										<option v-for="sub in form.sub" :value="sub.codeCode" :key="sub.id">{{sub.codeName}}</option>
									</b-select>
								</div>
							</div>
							<div class="form-row col-md-4 d-block position-relative float-left">
								<div class="form-group">
									<label for="input4">부서 관리자</label>
									<b-field>
										<b-switch 
											id="manager"
											v-model="isManager"
											@click.native="managerHandler()" 
										>
										</b-switch>
									</b-field>
								</div>
							</div>
							<div class="form-row col-md-5 d-block position-relative float-left">
								<div class="form-group">
									<label for="input5">기관 <span class="tx-danger">*</span><b-tag type="is-primary" attached aria-close-label="Close tag" class='d-inline-flex mb-0 ml-2' v-for="form in selectData" :key="form.id" v-if="form.idx == 1"> {{form.name}}</b-tag></label>
									<b-menu :accordion="false">
										<b-menu-list>
											<b-menu-item :expanded="true" v-for="form in companyData" :key="form.id" :label="form[companyNameCode]" :id="form.id" @click="classifyDepartment(form.id, form[companyNameCode])" icon="briefcase" class="tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1"></b-menu-item>
										</b-menu-list>
									</b-menu>
								</div>
							</div>
							<div class="form-row col-md-6 d-block position-relative float-left">
								<div class="form-group">
									<label for="input4">부서 <b-tag type="is-primary" attached aria-close-label="Close tag" class='d-inline-flex mb-0 ml-2' v-for="form in selectData" :key="form.id" v-if="form.idx == 2">{{form.name}}</b-tag></label>
									<b-menu :accordion="false">
										<b-menu-list :accordion="true" label="">
											<b-menu-item :expanded="true" :disabled="false" v-for="form in setDept" :key="form.id" :label="form.kor" :id="form.id" @click="selectEvent(2, form.id, form.kor)"icon="home" class="tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1">
												<b-menu-item :expanded="true" :disabled="false" v-for="child in form.child" :key="child.id" :label="child.kor" :id="child.id" @click="selectEvent(2, child.id, child.kor)"icon="folder-multiple-outline" class="tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1">
													<b-menu-item :expanded="true" :disabled="false" v-for="child2 in child.child" :key="child2.id" :label="child2.kor" :id="child2.id" @click="selectEvent(2, child2.id, child2.kor)" icon="folder-outline" class="tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1">
														<b-menu-item :expanded="true" :disabled="false" v-for="child3 in child2.child" :key="child3.id" :label="child3.kor" :id="child3.id" @click="selectEvent(2, child3.id, child3.kor)" icon="folder-outline" class="tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1">
														</b-menu-item>
													</b-menu-item>
												</b-menu-item>
											</b-menu-item>
										</b-menu-list>
									</b-menu>
								</div>
							</div>
							<div class="form-row col-md-6 d-block position-relative float-left" v-if="this.saveMode=='update'">
								<div class="form-group">
									<label class="label-title">Status</label>
									<div class="input-group">
										<div class="ml-2 custom-control custom-radio mb-1">
											<input type="radio" v-model.trim="usedCode" name="usedcode" id="usedcode1" value="1" class="custom-control-input">
											<label class="custom-control-label" for="usedcode1">Used</label>
										</div>
										<div class="ml-2 custom-control custom-radio mb-1">
											<input type="radio" v-model.trim="usedCode" name="usedcode" id="usedcode0" value="0" class="custom-control-input form-check-input">
											<label class="custom-control-label" for="usedcode0">Unused</label>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div><!-- card -->
				</div>		
			</div>
		</div>
	</div>
</template>

<script>
	import Handsontable from 'handsontable';
	import {HotTable} from '@handsontable/vue';
	import 'handsontable-key-value';
	import common from '@/views/Common/common.js';

	//암호화
	import {secretKey} from '@/config/config';
	import crypto from 'crypto-js';

	import {bus} from '../../../main';

	export default {
		name: 'Detail',
		props: ['properties'],
		components: {
		HotTable
		},
		computed: {
			sheetSettings() {
				let settings = this.$store.getters.sheetSettings;
				return settings;
			},
			filteredDataArray() {;
				return this.data.filter((option) => {
					return option.toString().toLowerCase().indexOf(this.companyName.toLowerCase()) >= 0
				});
			}
		},
		data() {
			return {
				mainName: '',
				subName: '',
				menuData: [],
				saveMode: '',

				mid: '', 
				uid: '', 
				msid: '',
				ssid: '',

				userHeader:[],
				
				userId: '',
				password: '',
				passwordRe: '',
				userName: '',
                email: '',
                phone: '',
				companyName: '',
				usedCode: '',
				userDept: '',
				official: '',
				position: '',
				companyData: [],
				companyNameCode: [],
				deptData: [],
				setDept: [],
				selectData: [],

				codeData: [],

				flag: false,

				/* Loading */
				isLoading: false,
				isFullPage: true,

				data: [],
				name: '',
				selected: null,
				isManager: false,

				departmentId: '',
				managerId:'',
			}
		},
		beforeDestroy(){
			bus.$off('menu_data');
		},
		created() {
			this.getAutoCompleteData();
			bus.$on('menu_data', (data)=>{
				this.menuData = data;
				this.modeFilter();
				this.codeSearch();
				this.classifyHeader();
				this.classifyCompany();
			});

			this.uid = this.properties.uid;
			this.mid = this.properties.mid;

		},
		mounted() {
		
		},
		watch: {
			selectData: function() {
				if (this.properties.uid) {
					if (this.selectData[1]) {
						if (this.selectData[1].id != this.departmentId) {
							this.isManager = false;
						} else {
							if (this.managerId == this.properties.uid) {
								this.isManager = true;
							}
						}
					}
				}
			},
		},
		methods : {
			async managerHandler() {
				// 0. 추후 MANAGEMENT 관리자만 관리자 체크 가능하게 / 직급 부서등 검토 필요 
				// 1. this.isManager가 true 인지 (buefy 버그로 false 가 true 인 상황)
				if (!this.isManager) {
					
					// 2. 부서 선택 여부
					if (this.selectData[1]) {
						let params = [];
						params = this.selectData[1];
						let request = {params: params};
						// 3. 선택 시 부서 관리자 있는지 체크 (axios/get)
						try {
							const check = await this.$axios.get(this.$apiHost + '/depts/check', request);
							if (check.data.flag) {
								this.managerId = check.data.managerId;
								if (this.managerId == this.properties.uid) {
									return false;
								}
								this.$buefy.dialog.confirm({
									message: check.data.message,
									size: 'is-medium',
									onConfirm: async () => {
										this.delExistManager(request);
										return false;
									},
									onCancel: () => {
										this.isManager = false;
										return false;
									}
								});					
							}
						} catch (error) {
							console.log(error)							
						}
						// 4. 관리자 없으면 true -> 저장 시 데이터 가공/ 있으면 기존 부서 관리자를 해제 하시겠습니까? yes -> 관리자 풀기 (axios/post)  
					} else {
						this.$buefy.notification.open({
							duration: 2000,
							message: `부서를 선택해주세요.`,
							position: 'is-bottom-right',
							type: 'is-danger',
							hasIcon: true
						})
						this.isManager = true;
					}

				}
			},
			async delExistManager(request) {
				try {
					const deleteManager = await this.$axios.get(this.$apiHost+'/'+this.$route.name.replace('_detail','')+'/delmanager', request);
					if (deleteManager.data.flag) {
						this.$buefy.notification.open({
							duration: 2000,
							message: `해제 완료.`,
							position: 'is-bottom-right',
							type: 'is-success',
							hasIcon: true
						})
					} 
					
				} catch (error) {
					console.log(error)
				}
		
			},
			async classifyHeader() {
				let data = common.menuHeader(this.properties.mid, this.menuData, 3);
				this.mainName = data[0];
				this.subName  = data[1];
				this.msid = data[2];
				this.userHeader = data[3];
			},
			async getAutoCompleteData() {
				await this.$axios.get(this.$apiHost + '/'+this.$route.name.replace('_detail','')+'/auto')
				.then(res => {
					let compN=[];
					let jsonArr = [];//id,name convert에 사용
					for (let i in res.data) {
						let json = { 'companyName': res.data[i].companyName, 'companyId': res.data[i].companyId}
						compN.push(res.data[i].companyName);
						jsonArr.push(json);
					}
					this.companyData = jsonArr;//
					this.data = compN;//자동완성 데이터
				}); 
			},
			goList() {
				if (this.flag) {
					//등록, 수정 완료시 바로 리스트로 가기때문에 
				} else {
					this.$buefy.dialog.confirm({
						message: "You didn't do anything. Would you like to go to the list?",
						size: 'is-medium',
						onConfirm: async () => {
							this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.mid, type:'list'}});
						},
						onCancel: () => {
							return false;
						}
					});
				}
			},
			async modeFilter() { //create, update 구분 
				if (this.properties.uid) {//update
					this.saveMode = 'update';
				
					//update data가져오기
					await this.$axios.get(this.$apiHost + '/'+this.$route.name.replace('_detail','')+'/content', {params:{'id':this.properties.uid}})
					.then(res => {
						this.userId = res.data.userId;
						this.userName = res.data.userName;
                        this.phone = res.data.phone;
                        this.email = res.data.email;
						this.companyName = res.data.companyName;
						this.usedCode = res.data.usedCode;
						this.$refs.userId.readOnly = true;
						this.official = res.data.official;
						this.position = res.data.position;
						this.isManager = res.data.manager ? true : false;
						this.departmentId = res.data.departmentId;
						if(!common.isNull(res.data.companyId.length)) this.classifyDepartment(res.data.companyId, res.data.companyName);
						if(!common.isNull(res.data.departmentId.length)) this.selectEvent(2, res.data.departmentId, res.data.departmentName);
						if (res.data.manager) {
							this.managerId = res.data.id;
						}
					}).catch((error) => {});
				} else {//insert
					this.saveMode = 'insert';
				}
			},
			async addCompany() {
				if (!this.userId) {
					this.$buefy.dialog.alert({
						message: 'Please enter User Id.',
						size: 'is-medium',
						type: 'is-danger'
					})
					this.$refs.userId.focus();
					return false;

				} else if (!this.password) {
					this.$buefy.dialog.alert({
						message: 'Please enter password.',
						size: 'is-medium',
						type: 'is-danger'
					})
					this.$refs.password.focus();
					return false;

				} else if (!this.passwordRe) {
					this.$buefy.dialog.alert({
						message: 'Please enter password.',
						size: 'is-medium',
						type: 'is-danger'
					})
					this.$refs.passwordRe.focus();
					return false;
				} else if (this.password != this.passwordRe) {
					this.$buefy.dialog.alert({
						message: 'The password is different.',
						size: 'is-medium',
						type: 'is-danger'
					})
					this.$refs.passwordRe.focus();
					this.passwordRe = "";
					return false;
				} else if (!this.userName) {
					this.$buefy.dialog.alert({
						message: 'Please enter User Name.',
						size: 'is-medium',
						type: 'is-danger'
					})
					this.$refs.userName.focus();
					return false;

				} else if (!this.companyName) {
					this.$buefy.dialog.alert({
						message: 'Please enter Company Name.',
						size: 'is-medium',
						type: 'is-danger'
					})
					// this.$refs.companyName.focus();
					return false;
				}

				this.$buefy.dialog.confirm({
					message: 'Would you like to register?',
					size: 'is-medium',
					onConfirm: async () => {
						let passChange = crypto.AES.encrypt(this.password,secretKey).toString(); //password 암호화
						const userId = this.userId;
						const password = passChange;
						const userName = this.userName;
						const phone = this.phone;
						const email = this.email;
						const companyId = this.selectData[0].id;
						const departmentId = common.isNull(this.selectData[1]) ? null : this.selectData[1].id;
						const official = this.official.length > 0 ? this.official : null;
						const position = this.position.length > 0 ? this.position : null;
						const manager = this.isManager ? 1 : 0;
						console.log(manager)	
						this.$axios.post(this.$apiHost + '/'+this.$route.name.replace('_detail','')+'/add', { userId, password, userName, companyId, departmentId, position, official, manager})
						.then((res) => {
							if (res.data.deduplication) {//중복
								alert(res.data.msg);
								this.userId = "";
								this.$refs.userId.focus();
							} else if (!res.data.deduplication) { //등록 완료
								this.$buefy.dialog.confirm({
									message: 'You have created user. Would you like to leave?',
									size: 'is-medium',
									onConfirm: async () => {
										this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.mid, type:'list'}});
									},
									onCancel: () => {
										return false;
									}
								});
							}
						});
					},
					onCancel: () => {
						return false;
					}
				});
			},
			async updateCompany() {
				if (!this.userId) {
					this.$buefy.dialog.alert({
						message: 'Please enter User Id.',
						size: 'is-medium',
						type: 'is-danger'
					})
					this.$refs.userId.focus();
					return false;
				} else if (!this.userName) {
					this.$buefy.dialog.alert({
						message: 'Please enter User Name.',
						size: 'is-medium',
						type: 'is-danger'
					})
					this.$refs.userName.focus();
					return false;
				} else if (!this.companyName) {
					this.$buefy.dialog.alert({
						message: 'Please enter Company Name.',
						size: 'is-medium',
						type: 'is-danger'
					})
					return false;
				}
				this.$buefy.dialog.confirm({
					message: 'Would you like to modify?',
					size: 'is-medium',
					onConfirm: async () => {
						let passChange = '';
						if (this.password) passChange = crypto.AES.encrypt(this.password,secretKey).toString(); //password 암호화
	
						const userId = this.userId;
						const userName = this.userName;
						const phone = this.phone;
						const email = this.email;
						const usedCode = this.usedCode;
						const companyId = this.selectData[0].id;
						const uid		 = this.uid;
						const password = passChange;
						const departmentId = common.isNull(this.selectData[1]) ? null : this.selectData[1].id;
						const official = this.official.length > 0 ? this.official : null;
						const position = this.position.length > 0 ? this.position : null;
						const manager = this.isManager ? 1 : 0;
						this.$axios.patch(this.$apiHost + '/'+this.$route.name.replace('_detail','')+'/update/user', { userId, password, userName, phone,email,usedCode, companyId, uid, departmentId, position, official, manager})
						.then((res) => {
							if (res.data.updateResult) {
								this.$buefy.dialog.confirm({
									message: 'You have changed data. Would you like to leave?',
									size: 'is-medium',
									onConfirm: async () => {
										this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.mid, type:'list'}});
									},
									onCancel: () => {
										return false;
									}
								});
							} else {
								this.$buefy.dialog.alert({
									message: 'Registration Failed.',
									size: 'is-medium',
									type: 'is-danger'
								})
							}
						});
					},
					onCancel: () => {
						return false;
					}
				});
				
			},
			saveFilter() {
				if (this.saveMode == 'insert') this.addCompany();
				else if (this.saveMode == 'update') this.updateCompany();
			},
			/*
			* Load Data Company
			*/
			async classifyCompany(){
				let menuid = common.menuidSearch(this.menuData, 'companies')
				let companyHeader = common.menuHeader(menuid, this.menuData)[3];
				this.companyNameCode = common.find_last_column(companyHeader, 'companyname');
				var params = { mid: menuid };
				var request = { params: params };
				await this.$axios.get(this.$apiHost + "/companies/search", request)
				.then(res => {
					this.companyData = res.data.list
				})
				.catch(error => {throw error;});
			},
			/*
			* Load Data Department Headers & depth type array setting
			*/
			async classifyDepartment(companyid, companyname){
				this.deptData = [];
				var params = { companyId: companyid };
				var request = { params: params };
				await this.$axios.get(this.$apiHost + "/depts", request)
				.then(res => {
					this.deptData = res.data;
				})
				let dept_a = [];
				this.deptData.forEach(a=>{
					a.child = [];
					if(Number(a.depth) === 0){
						dept_a.push(a);
					}else if(Number(a.depth) === 10){
						if(dept_a[0].id === a.parentId){
							dept_a[0].child.push(a);
						}
					}else if(Number(a.depth) === 100){
						dept_a[0].child.forEach((b, c)=>{
							if(b.id === a.parentId){
								dept_a[0].child[c].child.push(a);
							}
						});
					}else if(Number(a.depth) === 1000){
						dept_a[0].child.forEach((b, c)=>{
							b.child.forEach((d, e)=>{
								if(d.id === a.parentId){
									dept_a[0].child[c].child[e].child.push(a);
								}
							});
						});
					}
				});
				this.setDept = dept_a;
				this.selectEvent(1, companyid, companyname);
			},
			/*
			* company, menu select event
			*/
			async selectEvent(idx, id, name){
				let spid = ''
			
				if(this.selectData.length > 0){
					this.selectData.some((a,b)=>{
						if(idx == a.idx){
							spid = a.id
							this.selectData.splice(b, 1);
							if(idx === 1) this.companyName = '';
							return true
						}
					});
					if(id != spid){
						this.selectData.push({idx: idx, id: id, name: name});
						this.selectData.sort((a, b)=>{return a.idx - b.idx;});
					
					}
				}else{
					this.selectData.push({idx: idx, id: id, name: name});
				}
				if(idx === 1) this.companyName = name;
			},
			/*
			* 직급 (C022), 직책 (C023)
			*/
			async codeSearch(){
				var params = ['C022', 'C023'];
				var request = { params: params };
				let codeData = [{code: '', sub: []},{code: '', sub: []}];
				let thisCode = '';
				await this.$axios.get(this.$apiHost + "/codes/position", request)
				.then(res => {
					res.data.sort((a, b)=>{
						if(a.headerCode > b.headerCode) return 1;
						else if(a.headerCode < b.headerCode) return -1;
						return 0
					}); // 정렬 이후 make data
					res.data.forEach((a, b)=>{
						if(b === 0) {
							thisCode = a.headerCode;
							codeData[0].code = a.headerCode;
							codeData[0].sub.push(a);
						}else{
							if(thisCode === a.headerCode){
								codeData[0].sub.push(a);
							}else{
								codeData[1].code = a.headerCode;
								codeData[1].sub.push(a);
							}
						}
					});
					this.codeData = codeData;
				}).catch(err=>{console.log(err)});
			},
		},
	}
</script>
<style>
	div.bs {margin-left: 0px;}
	div.bs2 {margin-top: auto;}
	div.bstest {
		width: 50%;
		margin-left: 290px;
	}
	
</style>
<style src="../../../../node_modules/handsontable/dist/handsontable.full.css"></style>
<style scoped>
	@import '../../../assets/css/buefy.css';
</style>


// WEBPACK FOOTER //
// src/views/Management/User/DetailForm.vue